import { decrementItemQuantity } from '@jetshop/core/data/mutations/cartMutations.gql';
import React, { useContext } from 'react';
import { Mutation } from 'react-apollo';
import { getDecrementQuantityOptimisticResponse } from './cartMutationUtils';
import { CartIdContext } from '../Cart/CartIdContext';
import throwErrorInDev from '../../helpers/throwErrorInDev';
const DecrementQuantity = ({ children, cartQuery }) => {
    throwErrorInDev(!cartQuery, `You forgot to pass 'cartQuery' to DecrementQuantity`);
    const { cartId } = useContext(CartIdContext);
    return (React.createElement(Mutation, { mutation: decrementItemQuantity }, (mutate, { client }) => {
        return children((itemId) => {
            return mutate({
                variables: {
                    input: {
                        cartId,
                        itemId
                    }
                },
                optimisticResponse: {
                    decrementItemQuantity: {
                        cart: getDecrementQuantityOptimisticResponse({
                            itemId,
                            client,
                            cartId,
                            cartQuery
                        }),
                        __typename: 'CartMutation'
                    }
                }
            });
        });
    }));
};
export default DecrementQuantity;
//# sourceMappingURL=DecrementQuantity.js.map